import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NotificationEventContext } from "./NotificationEventContext";

export const NotificationEventEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["notification-event", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const notificationEventContext = useContext(NotificationEventContext);
    const { notificationEvents, setNotificationEvents, notificationEvent, setNotificationEvent, notificationEventDialog, setNotificationEventDialog } = notificationEventContext;

    const hideDialog = () => {
        setNotificationEventDialog(false);
    };

    const ngayNhanInput = () => {
        if (notificationEvent?.ngayTao) {
            return notificationEvent?.ngayTao.replaceAll("-", "/");
        }
        return null;
    };

    const getNoiDungSms = () => {
        if (notificationEvent?.noiDungSms) {
            const noiDungSms = notificationEvent.noiDungSms;
            return noiDungSms ? noiDungSms.content : null;
        }

        return null;
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={notificationEventDialog} style={{ width: "70%" }} header={t("notification-event.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* tên đăng nhập */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="soCccd">{t("notification-event.soCccd")}</label>
                                    <InputText name="soCccd" id="soCccd" value={notificationEvent?.soCccd} readOnly={true} />
                                </div>

                                {/* số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="soDienThoai">{t("notification-event.soDienThoai")}</label>
                                    <InputText name="soDienThoai" id="soDienThoai" value={notificationEvent?.soDienThoai} readOnly={true} />
                                </div>

                                {/* ngày nhận */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="ngayTao">{t("notification-event.ngayTao")}</label>
                                    <InputText name="ngayTao" id="ngayTao" value={ngayNhanInput()} readOnly={true} />
                                </div>

                                {/* trạng thái */}
                                {/* <div className="field col-12 md:col-3">
                                    <label htmlFor="trangThai">{t("notification-event.trangThai")}</label>
                                    <InputText name="trangThai" id="trangThai" value={notificationEvent?.trangThai} readOnly={true} />
                                </div> */}
                            </div>

                            <div className="grid">
                                {/* dich vụ */}
                                <div className="field col-12 md:col-9">
                                    <label htmlFor="maDichVu">{t("notification-event.tenDichVu")}</label>
                                    <InputText name="maDichVu" id="maDichVu" value={notificationEvent?.tenDichVu} readOnly={true} />
                                </div>

                                {/* loại yêu cầu */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="tenLoaiYeuCau">{t("notification-event.tenLoaiYeuCau")}</label>
                                    <InputText name="tenLoaiYeuCau" id="tenLoaiYeuCau" value={notificationEvent?.tenLoaiYeuCau} readOnly={true} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* nội dung */}
                                <div className="field col-12">
                                    <label htmlFor="noiDungSms">{t("notification-event.noiDungSms")}</label>
                                    <InputTextarea name="noiDungSms" id="noiDungSms" value={notificationEvent?.noiDungSms} autoFocus readOnly={true} rows={5} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
